import { useState, useCallback } from 'react';
import { SortConfig, SortOrder } from '../types';

export const useSorting = () => {
  const [sortConfigs, setSortConfigs] = useState<SortConfig[]>([]);

  const handleSort = useCallback((columnId: string) => {
    setSortConfigs((prevConfigs) => {
      const existingIndex = prevConfigs.findIndex((config) => config.column === columnId);

      if (existingIndex !== -1) {
        // Column already being sorted, cycle through: asc -> desc -> none
        const currentOrder = prevConfigs[existingIndex].order;
        const newOrder: SortOrder =
          currentOrder === 'asc' ? 'desc' : currentOrder === 'desc' ? 'none' : 'asc';

        if (newOrder === 'none') {
          // Remove this column from sorting
          return prevConfigs.filter((_, index) => index !== existingIndex);
        } else {
          // Update the order
          const newConfigs = [...prevConfigs];
          newConfigs[existingIndex] = { column: columnId, order: newOrder };
          return newConfigs;
        }
      } else {
        // New column, add with 'asc' order
        return [...prevConfigs, { column: columnId, order: 'asc' }];
      }
    });
  }, []);

  const clearSorting = useCallback(() => {
    setSortConfigs([]);
  }, []);

  return {
    sortConfigs,
    handleSort,
    clearSorting,
  };
};
